<script setup>
import GoogleSearchConsoleForm from '@frontJs/components/forms/projectManagement/customers/externalServices/GoogleSearchConsoleForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { tenant, externalService, websiteVariants } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    externalService: {
        type: Object,
        required: true,
    },
    websiteVariants: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>
            Google Search Console - Services externes - Clients - Gestion de
            projet - Datakepler
        </title>
    </Head>

    <PageTitle :tenant-name="tenant.name">
        Gestion de projet - Clients - Services externes - Google Search Console
    </PageTitle>

    <GoogleSearchConsoleForm
        :tenant="tenant"
        :external-service="externalService"
        :website-variants="websiteVariants"
    />
</template>
